var English = "Englisch";
var French = "Französisch";
var German = "Deutsch";
var Italian = "Italienisch";
var Japanese = "Japanisch";
var Korean = "Koreanisch";
var Portuguese = "Portugiesisch";
var Russian = "Russisch";
var Spanish = "Spanisch";
var Bahasa = "Bahasa";
var Thai = "Thai";
var Vietnamese = "Vietnamesisch";
var Turkish = "Türkisch";
var Arabic = "Arabisch";
var languagePreference = {
	English: English,
	French: French,
	German: German,
	Italian: Italian,
	Japanese: Japanese,
	Korean: Korean,
	Portuguese: Portuguese,
	Russian: Russian,
	"Chinese-Simplified": "Chinesisch (vereinfacht)",
	"Chinese-Traditional": "Chinesisch (traditionell)",
	Spanish: Spanish,
	Bahasa: Bahasa,
	Thai: Thai,
	Vietnamese: Vietnamese,
	Turkish: Turkish,
	Arabic: Arabic
};

export { Arabic, Bahasa, English, French, German, Italian, Japanese, Korean, Portuguese, Russian, Spanish, Thai, Turkish, Vietnamese, languagePreference as default };
